import React, { useState } from 'react';
import BookingRow from './BookingRow';

const fmtMoney = (n) => {
  if (n == null || Number.isNaN(Number(n))) return '—';
  return `₹${Number(n).toFixed(2)}`;
};

const fmtNum = (n, digits = 2) => {
  if (n == null || Number.isNaN(Number(n))) return '—';
  return Number(n).toFixed(digits);
};

const DateSection = ({ displayLabel, bookings, dailyEarnings }) => {
  const [detailsOpen, setDetailsOpen] = useState(false);

  const hasEarnings =
    dailyEarnings &&
    dailyEarnings.id != null &&
    typeof dailyEarnings.subtotal === 'number';
  const subtotal = hasEarnings ? dailyEarnings.subtotal : null;
  const tollTotal = hasEarnings ? Number(dailyEarnings.toll_total || 0) : 0;
  const dayPay =
    hasEarnings ? Number(subtotal) + tollTotal : null;

  return (
    <div className="date-section">
      {/* Commented out date header with earnings per user request (showing pay per booking instead) */}
      {/*
      <div className="date-header date-header--with-earnings">
        <div className="date-header__left">
          <span className="date-header__icon" aria-hidden>📅</span>
          <span className="date-header__label">{displayLabel}</span>
        </div>
        <div className="date-header__right">
          {hasEarnings && (
            <span
              className="date-header__earnings"
              title="Daily pay: formula subtotal + deduplicated tolls"
            >
              {fmtMoney(dayPay)}
            </span>
          )}
          <button
            type="button"
            className="date-header__details-btn"
            onClick={() => setDetailsOpen((o) => !o)}
            aria-expanded={detailsOpen}
          >
            {detailsOpen ? 'Hide' : 'Details'}
          </button>
        </div>
      </div>

      {detailsOpen && (
        <div className="daily-earnings-panel">
          {!hasEarnings ? (
            <p className="daily-earnings-panel__empty">
              No daily earnings record for this date yet. It is written when trip payment updates run
              (see <code>trip.driver_daily_earnings</code>).
            </p>
          ) : (
            <div className="daily-earnings-grid">
              <div className="daily-earnings-group">
                <h4 className="daily-earnings-group__title">Distance &amp; trips</h4>
                <ul className="daily-earnings-kv">
                  <li><span>Total distance (km)</span><b>{fmtNum(dailyEarnings.total_km)}</b></li>
                  <li><span>Active km</span><b>{fmtNum(dailyEarnings.total_active_km)}</b></li>
                  <li><span>Initial dead km</span><b>{fmtNum(dailyEarnings.total_initial_dead_km)}</b></li>
                  <li><span>Final dead km</span><b>{fmtNum(dailyEarnings.total_final_dead_km)}</b></li>
                  <li><span>Trips (count)</span><b>{dailyEarnings.num_trips ?? '—'}</b></li>
                  <li><span>Vehicle class</span><b>{dailyEarnings.vehicle_class ?? '—'}</b></li>
                </ul>
              </div>
              <div className="daily-earnings-group">
                <h4 className="daily-earnings-group__title">Time (model)</h4>
                <ul className="daily-earnings-kv">
                  <li><span>Load time (mins)</span><b>{fmtNum(dailyEarnings.load_time_mins)}</b></li>
                  <li><span>Est. duration (mins)</span><b>{fmtNum(dailyEarnings.estimated_duration_mins)}</b></li>
                  <li><span>Total time (hrs)</span><b>{fmtNum(dailyEarnings.total_time_hrs)}</b></li>
                  <li><span>Capped time (hrs)</span><b>{fmtNum(dailyEarnings.capped_time_hrs)}</b></li>
                </ul>
              </div>
              <div className="daily-earnings-group">
                <h4 className="daily-earnings-group__title">Amounts (₹)</h4>
                <ul className="daily-earnings-kv">
                  <li><span>Fuel cost</span><b>{fmtMoney(dailyEarnings.fuel_cost)}</b></li>
                  <li><span>Running expense</span><b>{fmtMoney(dailyEarnings.running_expense)}</b></li>
                  <li><span>Fixed expense</span><b>{fmtMoney(dailyEarnings.fixed_expense)}</b></li>
                  <li><span>Margin</span><b>{fmtMoney(dailyEarnings.margin_amount)}</b></li>
                  <li>
                    <span>Subtotal (formula)</span><b>{fmtMoney(dailyEarnings.subtotal)}</b>
                  </li>
                  <li>
                    <span>Tolls (deduped day total)</span><b>{fmtMoney(dailyEarnings.toll_total)}</b>
                  </li>
                  <li className="daily-earnings-kv--highlight">
                    <span>Day pay (subtotal + tolls)</span>
                    <b>{fmtMoney(Number(dailyEarnings.subtotal || 0) + Number(dailyEarnings.toll_total || 0))}</b>
                  </li>
                </ul>
              </div>
              {dailyEarnings.toll_dedupe_json &&
                typeof dailyEarnings.toll_dedupe_json === 'object' &&
                Object.keys(dailyEarnings.toll_dedupe_json).length > 0 && (
                <div className="daily-earnings-group daily-earnings-group--full">
                  <h4 className="daily-earnings-group__title">Toll dedupe (audit)</h4>
                  <pre className="daily-earnings-json">
                    {JSON.stringify(dailyEarnings.toll_dedupe_json, null, 2)}
                  </pre>
                </div>
              )}
              <div className="daily-earnings-group">
                <h4 className="daily-earnings-group__title">Meta</h4>
                <ul className="daily-earnings-kv">
                  <li><span>Trip IDs</span>
                    <b className="daily-earnings-kv__trip-ids">
                      {Array.isArray(dailyEarnings.trip_ids) && dailyEarnings.trip_ids.length
                        ? dailyEarnings.trip_ids.join(', ')
                        : '—'}
                    </b>
                  </li>
                  <li><span>Record id</span><b>{dailyEarnings.id ?? '—'}</b></li>
                  <li><span>Calculated at</span><b>{dailyEarnings.calculated_at || '—'}</b></li>
                  <li><span>Updated at</span><b>{dailyEarnings.updated_at || '—'}</b></li>
                </ul>
              </div>
            </div>
          )}
        </div>
      )}
      */}

      <div className="bookings-list">
        {bookings.map((booking) => (
          <BookingRow key={booking.booking_id} booking={booking} />
        ))}
      </div>
    </div>
  );
};

export default DateSection;
